$(document).ready(function(){
  $("#fillable-body").bind("ajax:beforeSend", function(evt, xhr, settings){
    $(this).find('img').show();
  });
});
